/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignListResponseSchema,
  campaignSortSchema,
  campaignStatusSchema,
} from '../campaign-schema';
import { CAMPAIGN_SORT } from '../campaign-constants';

export const listCampaignsPathSchema = z.object({ workspaceId: z.string() });

export const listCampaignsQuerySchema = z.object({
  name: z.string().optional(),
  status: campaignStatusSchema.optional(),
  sort: campaignSortSchema.default(CAMPAIGN_SORT.START_DATE_DESC),
  page: z.number().int().default(1),
  limit: z.number().int().default(20),
});

export const listCampaignsOperationResponseSchema = campaignListResponseSchema;

export type ListCampaignsInput = {
  path: z.input<typeof listCampaignsPathSchema>;
  query?: z.input<typeof listCampaignsQuerySchema>;
  signal?: AbortSignal;
};

export async function listCampaigns({
  path,
  query,
  signal,
}: ListCampaignsInput): Promise<
  z.infer<typeof listCampaignsOperationResponseSchema>
> {
  const parsedPath = listCampaignsPathSchema.parse(path);
  const parsedQuery = listCampaignsQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `workspaces/${parsedPath.workspaceId}/campaigns`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listCampaignsOperationResponseSchema.parse(await response.json());
}
